import { seedCarriedAutoParties, seedCarriedInvolvedParties } from '../InvolvedParties';

interface FnolFormValues extends Record<string, unknown> {
  loss_location?: Record<string, unknown>;
  configured_fields_values?: Record<string, unknown>;
  first_party_values?: Record<string, unknown>[];
  third_party_values?: Record<string, unknown>[];
  first_party?: Record<string, unknown>;
  third_party_vehicles?: Record<string, unknown>[];
  third_party_non_motorists?: Record<string, unknown>[];
  third_party_other_properties?: Record<string, unknown>[];
}

/**
 * Merge a Create Like draft into the FNOL form's seeded initial values.
 *
 * The draft holds only the values portable from the source claim, so spreading it wholesale would
 * replace whole objects and leave every key it omits `undefined` instead of seeded — selects render
 * out of range and multiselects lose their `[]`. The nested objects are merged into their seeds
 * instead, and carried parties — the general-claim lists, and the auto insured party and third-party
 * rows — are re-seeded over the blank-party skeleton so their shape matches manually-added parties.
 * The party re-seeding must come after the draft spread, or the raw draft parties would overwrite it.
 */
export const applyCreateLikeDraft = (
  seeded: FnolFormValues,
  draft: FnolFormValues | null | undefined,
  incidentConfiguration: unknown
): FnolFormValues => {
  if (!draft) {
    return seeded;
  }
  return {
    ...seeded,
    ...draft,
    loss_location: { ...seeded.loss_location, ...draft.loss_location },
    configured_fields_values: { ...seeded.configured_fields_values, ...draft.configured_fields_values },
    ...(draft.first_party_values
      ? { first_party_values: seedCarriedInvolvedParties(incidentConfiguration, draft.first_party_values) }
      : {}),
    ...(draft.third_party_values
      ? { third_party_values: seedCarriedInvolvedParties(incidentConfiguration, draft.third_party_values) }
      : {}),
    ...seedCarriedAutoParties(incidentConfiguration, seeded, draft),
  };
};
